
import { defineComponent, PropType } from 'vue'

// composable
import { useFile } from '@/common/composable/useFile'

// types
import { TtnFile } from '@/new-services/types/tms'

export default defineComponent({
    props: {
        files: {
            type: Array as PropType<TtnFile[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Файлы',
        },
    },
    setup() {
        const { saveFileByURL } = useFile()

        const isPDF = (url: string) => {
            const url_arr = url.split('.')
            const extension = url_arr[url_arr.length - 1]

            return extension === 'pdf'
        }

        const download = async (download_url: string) => {
            saveFileByURL(download_url)
        }

        return { isPDF, download }
    },
})
